import { useState, ReactNode } from 'react';
import { useAppConfigContext } from '@/context/AppConfig';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import { Text, styled, Icons } from '@/theme/index';

// STYLING

export const LearnMoreToggleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
}));

const ExpandCircleUpWithMargin = styled(Icons.ExpandCircleDown)(
  ({ theme }) => ({
    transform: 'rotate(180deg)',
    marginRight: theme.spacing(0.75),
    color: theme.palette.primary.main,
    fontSize: '1.25rem',
  })
);

const ExpandCircleDownWithMargin = styled(Icons.ExpandCircleDown)(
  ({ theme }) => ({
    marginRight: theme.spacing(0.75),
    color: theme.palette.primary.main,
    fontSize: '1.25rem',
  })
);

const LearnMoreText = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  cursor: 'pointer',
}));

// Components

export function LearnMoreToggle() {
  const { trackEvent } = useAppConfigContext();
  const [learnMoreOpen, setLearnMoreOpen] = useState<boolean>(false);

  const handleLearnMoreToggle = () => {
    setLearnMoreOpen((prevState: boolean) => !prevState);
  };

  const displayLearnMore = () => {
    if (learnMoreOpen) {
      trackEvent('learn more', 'engagement click', 'notes section');
      return (
        <Text variant="body1">
          Adding notes is an easy way for you to keep detailed information about
          each of your reports, that is only visible to you.
        </Text>
      );
    }
  };

  return (
    <LearnMoreToggleContainer onClick={handleLearnMoreToggle}>
      <LearnMoreText variant="body1">
        {learnMoreOpen ? (
          <ExpandCircleUpWithMargin />
        ) : (
          <ExpandCircleDownWithMargin />
        )}
        Learn More
      </LearnMoreText>
      {displayLearnMore()}
    </LearnMoreToggleContainer>
  );
}

export function NotesSectionContainer({ children }: { children: ReactNode }) {
  return (
    <ReportSection sectionId="Notes-section" title="Notes" hasContent>
      {children}
    </ReportSection>
  );
}
